type ToastKind = 'info' | 'success' | 'error';

function host(): HTMLElement {
  let h = document.querySelector<HTMLElement>('.toast-host');
  if (!h) {
    h = document.createElement('div');
    h.className = 'toast-host';
    document.body.append(h);
  }
  return h;
}

export function toast(message: string, kind: ToastKind = 'info', durationMs = 3200): void {
  const el = document.createElement('div');
  el.className = `toast toast-${kind}`;
  el.textContent = message;
  host().append(el);
  requestAnimationFrame(() => el.classList.add('show'));
  window.setTimeout(() => {
    el.classList.remove('show');
    window.setTimeout(() => el.remove(), 220);
  }, durationMs);
}

export const toastError = (m: string): void => toast(m, 'error', 4500);
export const toastSuccess = (m: string): void => toast(m, 'success');
